import { render, staticRenderFns } from "./TripTableRow.vue?vue&type=template&id=511a87d1&scoped=true"
import script from "./TripTableRow.vue?vue&type=script&lang=js"
export * from "./TripTableRow.vue?vue&type=script&lang=js"
import style0 from "./TripTableRow.vue?vue&type=style&index=0&id=511a87d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a87d1",
  null
  
)

export default component.exports